/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_All_LocationsInputs */

const en_audit_all_locations = /** @type {(inputs: Audit_All_LocationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Locations`)
};

const es_audit_all_locations = /** @type {(inputs: Audit_All_LocationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las Ubicaciones`)
};

/**
* | output |
* | --- |
* | "All Locations" |
*
* @param {Audit_All_LocationsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_all_locations = /** @type {((inputs?: Audit_All_LocationsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_All_LocationsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_all_locations(inputs)
	return es_audit_all_locations(inputs)
});